import { compose, withHandlers, withState, mapProps } from 'recompose'
import { connect } from 'react-redux'

import {
  withTheme,
  withMeasure,
  withLoading,
  withImageLoading
} from 'modules/util'
import { Loading } from 'modules/ui'
import { Argument, Builder, Question } from '../../selectors'
import { isClaimComplete } from './util'
import builderTheme from './theme.scss'

const handleMeasure = ({ setContainerWidth }) =>
  ({ imageSize: { width } }) => setContainerWidth(width)

function mapStateToProps(state, props) {
  const id = parseFloat(props.match.params.id)

  return {
    argument: Argument.selected(id, state),
    loaded: Question.loaded(state),
    parts: Builder.parts(state)
  }
}

export default compose(
  connect(mapStateToProps),
  mapProps(props => ({ ...props, completed: isClaimComplete(props.parts) })),
  withState('containerWidth', 'setContainerWidth'),
  withMeasure(),
  withImageLoading(),
  withHandlers({ handleMeasure }),
  withTheme(builderTheme),
  withLoading(Loading)
)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Builder/enhancers.js